module.exports = require("appkit-react");